<script setup lang="ts">
import { maintenanceEnabled, skipMaintenance } from '@/components/goat/layout/maintenance/Maintenance'

const { triggerApi } = siteUtils
triggerApi.initTriggerApi()
const route = useRoute()
onMounted(() => {
  if (route.query.forceVisibility) {
    // forceVisibility=soccer-clash
    localStorage?.setItem?.(`id-visible_${route.query.forceVisibility}`, 'on')
    delete route.query.forceVisibility
    window.location.href = route.path
  }
  if (maintenanceEnabled.value) {
    const tokenMaintenance: string = import.meta.env.VITE_MAINTENANCE_TOKEN || ''
    if (route.query.skipMaintenance === tokenMaintenance) {
      localStorage?.setItem?.('s-m', String(route.query.skipMaintenance))
      maintenanceEnabled.value = false
      skipMaintenance.value = true
      delete route.query.skipMaintenance
      window.location.href = route.path
    } else if (localStorage?.getItem?.('s-m') === tokenMaintenance) {
      maintenanceEnabled.value = false
      skipMaintenance.value = true
    } else {
      maintenanceEnabled.value = true
      skipMaintenance.value = false
    }
  }
})
</script>

<template>
  <goat-layout-maintenance-maintenance v-if="maintenanceEnabled" />
  <template v-else>
    <goat-layout-page-loader />
    <goat-layout-install-prompt />
    <goat-layout-page-header />
    <router-view />
    <goat-layout-page-footer />
    <goat-layout-cookies-manager />
    <goat-layout-drawers-user />
  </template>
</template>

<style scoped lang="postcss">

</style>
